import Component from '@bythepixel/component-loader';
import { eventThrottle } from '@Core/utility';

export default class NavigationFooter extends Component {
  static selector = '[data-comp-navigationfooter]';

  constructor(el) {
    super(el);
    this.el = el;

    this.stickyButtons = document.querySelector('[data-sticky-buttons]');

    this.init();
  }

  init() {
    // Checks if there are sticky buttons, in which case the bottom padding of the footer needs to
    // change to accommodate (uses the offsetHeight which will be 0 if it's not shown)
    if (this.stickyButtons) {
      this.adjustForStickyButtons();

      window.addEventListener('resize', eventThrottle(() => this.adjustForStickyButtons(), 100));
    }
  }

  adjustForStickyButtons() {
    this.el.style.paddingBottom = `${this.stickyButtons.offsetHeight}px`;
  }
}
